import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ReservationsService } from '../../../services/reservations.service';
import { ReservationForm, ReservationFormResponse } from '../../../models/Reservation';

export interface DialogData {
  reservationData: ReservationForm|null,
  reservationResponse: ReservationFormResponse,
  errorType: number // 0 => Message, 1 => Warning,
}
@Component({
  selector: 'app-table-problems-dialog',
  templateUrl: './table-problems-dialog.component.html'
})
export class TableProblemsDialogComponent implements OnInit {
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<TableProblemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: ReservationsService,
    private translate: TranslateService,
    public router: Router
  ) { }

  ngOnInit(): void { }

  saveRecord() {
    if (!this.data.reservationData) return;
    this.loading = true;
    this.data.reservationData.reserveAnyWay = true;
    this.service.saveRecord(this.data.reservationData).subscribe((response) => {
      this.loading = false;
      if (response?.result?.success) {
        this.dialogRef.close('success');
      } else {
        this.data.reservationResponse = response;
      }
    }, error => {
      this.loading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    });
  }
}
